export default __webpack_public_path__ + "assets/USAA-7fe520372abec8027f0c64572a6f0af4.svg";